<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header-light page-title="AUDESP - FASE 4 [Pagamento]" fa-icon="file-signature">
          </lib-page-header-light>
          <span class="text-muted" style="font-size: 18px" *ngIf="entidade.id">
            <i [class]="'mt-2 ml-1 fa fa-arrow-circle-down' + (entidade.exportado ? ' text-primary' : '')"
              [title]="(entidade.exportado ? '' : 'Não ') + 'Exportado'"></i>
            <i [class]="'mt-2 ml-1 fa fa-arrow-circle-up' + (entidade.enviado ? ' text-primary' : '')"
              [title]="(entidade.enviado ? '' : 'Não ') + 'Enviado'"></i>
            <i [class]="'mt-2 ml-1 fa fa-check-circle' + (entidade.armazenado ? ' text-success' : '')"
              [title]="(entidade.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
          </span>
        </div>
        <div class="col-md-4">
          <button [routerLink]="['/licitacoes-audesp']" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="voltar" title="Voltar" height="20" width="20">
          </button>
          <div class="dropdown" *ngIf="entidade.id">
            <button class="btn btn-sm btn-outline-secondary float-right dropdown-toggle ml-2" type="button"
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Opções
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" (click)="validarXML()">
                Validar Registro
              </a>
              <a class="dropdown-item" (click)="gerarXML()">
                Gerar Arquivo XML
              </a>
              <a class="dropdown-item" (click)="atualizarStatus('ENVIADO', !entidade.enviado)">
                Marcar como {{entidade.enviado ? 'Não ' : ''}}Enviado
              </a>
              <a class="dropdown-item" (click)="atualizarStatus('ARMAZENADO', !entidade.armazenado)">
                Marcar como {{entidade.armazenado ? 'Não ' : ''}}Armazenado
              </a>
            </div>
          </div>
          <button *ngIf="ajuste?.armazenado && !entidade.enviado && !entidade.armazenado" (click)="submitForm()"
            class="btn btn-primary btn-sm float-right ml-2">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-3" />
      <div class="row text-muted" *ngIf="entidadeForm.get('licitacao')?.value">
        <div class="col-3">
          <label class="font-weight-bold">Nº Licitação:</label>
          <label class="ml-2">
            {{entidadeForm.get('licitacao')?.value?.numero | LICITACAO}}
          </label>
        </div>
        <div class="col-3">
          <label class="font-weight-bold">Nº Processo:</label>
          <label class="ml-2">
            {{entidadeForm.get('licitacao')?.value?.processo | LICITACAO}}
          </label>
        </div>
        <div class="col-3">
          <label class="font-weight-bold">Modalidade:</label>
          <label class="ml-2">
            {{entidadeForm.get('licitacao')?.value?.modalidade?.nome}}
          </label>
        </div>
        <div class="col-3">
          <a class="btn btn-link btn-sm text-danger float-right" data-toggle="modal" data-target="#dialogMensagensXML"
            *ngIf="mensagemXML">
            <i class="fa fa-exclamation-triangle"></i> Visualizar Inconsistências
          </a>
        </div>
      </div>
      <div class="row mt-2 text-muted" *ngIf="ajuste && registroPreco">
        <div class="col-3">
          <label class="float-left font-weight-bold">Código Licitação:</label>
          <button [routerLink]="['/licitacoes-audesp', registroPreco.id, 'editar']"
            class="btn btn-sm btn-link float-left p-0 ml-2">
            {{registroPreco.codigo}}
          </button>
        </div>
        <div class="col-3">
          <label class="float-left font-weight-bold">Código Ajuste:</label>
          <button [routerLink]="['/licitacoes-audesp', registroPreco.id, 'ajuste', ajuste.id, 'editar']"
            class="btn btn-sm btn-link float-left p-0 ml-2">
            {{ajuste.codigo}}
          </button>
        </div>
        <div class="col-3">
          <label class="font-weight-bold">Instrumento:</label>
          <label class="ml-2">
            {{ajuste.tipo}}
          </label>
        </div>
        <div class="col-12">
          <span class="text-muted font-italic">{{ajuste.identificacao}}</span>
        </div>
      </div>
      <hr />
      <lib-licitacao-audesp-pagamento [(entidade)]="entidade" [ajuste]="ajuste"></lib-licitacao-audesp-pagamento>
      <!-- <pre>{{ entidade.arquivo | json}}</pre> -->
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal fade" id="dialogMensagensXML" tabindex="-1" role="dialog" 
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        Inconsistências do Registro
      </div>
      <div class="modal-body p-1">
        <ul class="list-group list-group-flush text-muted">
          <li class="list-group-item p-1" *ngFor="let msg of mensagemXML" style="border-style: dashed">
            {{msg}}
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-sm text-danger" (click)="baixarXMLInvalido()"
          *ngIf="xmlInvalido">Baixar XML</button>
        <button type="button" class="btn btn-link btn-sm" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>